import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-aya-chat-followups',
  templateUrl: './aya-chat-followups.component.html',
  styleUrls: ['./aya-chat-followups.component.scss'],
})
export class AyaChatFollowupsComponent {
  @Input() items: string[] = [];
  @Output() select = new EventEmitter<string>();

  get visibleItems(): string[] {
    return this.items.slice(0, 3);
  }

  onSelect(item: string): void {
    this.select.emit(item);
  }
}
